import styled from "styled-components";
import Colors from "../../themes/Colors";

const UserSettingsHolder = styled.div`

  width: 100%;

  .profileHeader {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .pageTitle {
    color: ${Colors.coal};
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }
  .settingsCard {
    border: 1px solid ${Colors.borderStrong};
    border-radius: 8px;
    box-shadow: 0px 1px 1.5px rgba(0, 0, 0, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.1);
    margin: 0 0 15px;
  }
  .settingsCard .ant-card-body {
    padding: 21px 21px 29px;
  }
  .sectionTitle {
    color: ${Colors.textStrong};
    font-size: 20px;
    font-weight: 500;
    line-height: 31px;
    margin: 0 0 21px;
  }
  .profileInfo {
    display: flex;
    gap: 21px;
    align-items: flex-start;
  }
  .profileInfoFields {
    display: flex;
    flex-direction: column;
    gap: 21px;
    flex: 1;
    min-width: 0;
  }
  .fieldGroup {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .fieldLabel {
    color: ${Colors.textSecondary};
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    margin: 0;
  }
  .profileActions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .profileButton,
  .profileButton:hover,
  .profileButton:focus {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
    border-radius: 8px;
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.04);
    color: ${Colors.onPrimary};
  }
  .profileButton:hover,
  .profileButton:focus {
    opacity: 0.85;
  }
  .sectionDivider {
    border: 0;
    border-top: 1px solid ${Colors.borderStrong};
    margin: 28px 0;
  }
  .agencyData {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .agencyDataAddress {
    grid-column: 1 / -1;
  }
  .brandsTable .ant-table-small {
    border: 0;
    border-radius: 0;
  }
  .brandsTable .ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0;
  }
  .brandsTable .ant-table-thead > tr > th {
    background: transparent;
    border-bottom: 1px solid ${Colors.borderStrong};
    color: ${Colors.textSecondary};
    font-size: 12px;
    font-weight: 500;
  }
  .brandsTable .ant-table-tbody > tr > td {
    border-bottom: 1px solid ${Colors.borderStrong};
    color: ${Colors.textStrong};
    font-size: 12px;
  }
  .brandsTable .ant-table-tbody > tr:last-child > td {
    border-bottom: 0;
  }
  .brandsPagination {
    background: transparent;
    border-top: 1px solid ${Colors.borderStrong};
    padding: 14px 8px 0;
  }
  .brandBadges {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
  }
  .brandBadge {
    background: ${Colors.surfaceMuted};
    border-radius: 2px;
    color: ${Colors.textSecondary};
    font-size: 10.5px;
    line-height: 14px;
    padding: 2px 7px;
  }
  .profilePhoto {
    align-items: center;
    display: flex;
    flex: 0 0 280px;
    flex-direction: column;
    gap: 16px;
  }
  .profilePhotoWrapper {
    height: 200px;
    position: relative;
    width: 200px;
  }
  .profilePhotoWrapper .ant-upload {
    bottom: 0;
    position: absolute;
    right: 0;
  }
  .profilePhotoImage {
    border-radius: 50%;
    height: 200px;
    object-fit: cover;
    width: 200px;
  }
  @media (max-width: 767px) {
    .profileInfo {
      flex-direction: column;
    }
    .profilePhoto {
      flex-basis: auto;
      width: 100%;
    }
  }
  .cardInfo {
    font-size: 15px;
    font-weight: 600;
    color: ${Colors.coal};
    padding: 0 0 15px;
  }
  .cardInfoError {
    font-size: 15px;
    font-weight: 600;
    color: ${Colors.red};
    padding: 0 0 15px;
  }
  .cardInfoLink {
    font-size: 15px;
    font-weight: 600;
    color: ${Colors.primaryAccent};
    padding: 10px 0 0;
  }
  .cardInfoPrimary {
    font-size: 13px;
    color: ${Colors.primaryAccent};
    font-weight: 600;
  }
`;

export default UserSettingsHolder;
